var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.338,
    height: 12.364,
    viewBox: "0 0 19.338 12.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_182",
    "data-name": "Trac\\xE9 182",
    d: "M36.375,33.022a1.5,1.5,0,0,0,.953-1.376V30.639a1.472,1.472,0,0,0-1.472-1.472H24.842a.374.374,0,0,0-.374.374h0a.612.612,0,0,1-.528.619.589.589,0,0,1-.649-.586v-.034a.374.374,0,0,0-.374-.374H19.461a1.472,1.472,0,0,0-1.472,1.472v1.007a1.5,1.5,0,0,0,.953,1.376,2.515,2.515,0,0,1,0,4.653,1.5,1.5,0,0,0-.953,1.376v1.007a1.472,1.472,0,0,0,1.472,1.472h3.456a.374.374,0,0,0,.374-.374h0a.612.612,0,0,1,.528-.619.589.589,0,0,1,.649.586v.033a.374.374,0,0,0,.374.374H35.855a1.472,1.472,0,0,0,1.472-1.472V39.052a1.5,1.5,0,0,0-.953-1.376,2.515,2.515,0,0,1,0-4.653ZM24.468,39.663a.589.589,0,0,1-1.177,0v-1.9a.589.589,0,1,1,1.177,0Zm0-3.363a.589.589,0,0,1-1.177,0V34.4a.589.589,0,1,1,1.177,0Zm0-3.363a.589.589,0,0,1-1.177,0v-1.9a.589.589,0,1,1,1.177,0Z",
    transform: "translate(-17.989 -29.167)",
    fill: "#45434d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.500b66ab.svg";
export { ForwardRef as ReactComponent };